import MUIPeople from '@mui/icons-material/People'

export const PeopleIcon = MUIPeople
